export class NaiveDate extends Date {
  constructor(dateString: string | number) {
    // Split year, month, day into discreet components to prevent time zone correction from UTC
    if (typeof dateString === 'string') {
      dateString = dateString.trim()

      if (dateString.length == 10) {
        // Parse `YYYY-MM-DD` string
        if (dateString.indexOf('-') !== -1) {
          const parts = dateString.split('-').map((s) => parseInt(s, 10))
          super(parts[0], parts[1] - 1, parts[2])
          return
        }

        // Parse `MM/DD/YYYY` string
        if (dateString.indexOf('/') !== -1) {
          const parts = dateString.split('/').map((s) => parseInt(s, 10))
          super(parts[2], parts[0] - 1, parts[1])
          return
        }
      }
    }

    super(dateString)
  }
}

export const displayDate = (date: string) => {
  const dateFormat = new Date(date)
  const day = `${dateFormat.toDateString().split(' ')[0]}.`

  return `${day} ${dateFormat.getMonth() + 1}/${dateFormat.getDate()}`
}

export const displayFullNumericalDate = (date: string) => {
  const dateFormat = new Date(date)

  return `${dateFormat.getMonth() + 1}/${dateFormat.getDate()}/${dateFormat.getFullYear().toString().substring(2)}`
}

export const displayTime = (timestamp: string) => {
  const formatOptions = {
    hour: 'numeric',
    minute: 'numeric',
  }

  const date = new Date(timestamp)

  return date.toLocaleString(
    'en-US',
    formatOptions as Intl.DateTimeFormatOptions,
  )
}
